import React from 'react'
import cn from 'classnames'

import { Back } from '../Back'

import styles from './styles.module.scss'

const Safety = () => {
	return (
		<article className={styles.article}>
			<Back />
			<h1 className={styles.heading}>Надёжность сбережений</h1>

			<nav className={styles.nav}>
				<ul>
					<li className={styles.navItem}>
						<a className={styles.link} href='#protection'>
							Защита сбережений
						</a>
					</li>
					<li className={styles.navItem}>
						<a className={styles.link} href='#assessment-pledge'>
							Оценка залога
						</a>
					</li>
					<li className={styles.navItem}>
						<a className={styles.link} href='#assessment-borrower'>
							Оценка заёмщика
						</a>
					</li>
				</ul>
			</nav>

			<h3 id='protection' className={styles.title}>
				Защита сбережений
			</h3>
			<p className={styles.paragraph}>
				Мы создали продукт, в котором доходность гарантирована, а платежеспособность заёмщиков не
				влияет на сберегателей. У нас действует комплекс мер, направленных на защиту сбережений:
			</p>

			<ol className={styles.orderedList}>
				<li className={styles.orderedItem}>
					<b>Договор, который фиксирует выплаты и проценты.</b>
					Он заключается между «Фондом Ипотечного Кредитования» и сберегателем. Поэтому клиент точно
					знает, когда и сколько будет получать.
				</li>
				<li className={styles.orderedItem}>
					<b>Залог — ликвидные квартиры в крупных городах. </b> Каждое сбережение защищено залогом
					ликвидных квартир. В крайнем случае команда наших юристов обращает взыскание через продажу
					объекта с торгов, а деньги для выплат возвращаются в компанию. Но это наши внутренние
					процессы, от сберегателя в этом случае ничего не требуется, он спокойно продолжает
					получать доходность.
				</li>
				<li className={styles.orderedItem}>
					<b>Диверсификация: сбережения клиентов распределены между разными займами.</b>Если один
					заёмщик пропустит пару платежей — деньги компенсируются за счет другого.{' '}
				</li>
				<li className={styles.orderedItem}>
					<b>
						Компенсационный фонд СРО — выплачивает частичную компенсацию пайщикам в случае
						банкротства КПК.
					</b>
					КПК по закону обязан быть членом саморегулируемой организации (СРО), которая помогает
					Центробанку в надзоре за кооперативом. Но ещё у каждой СРО есть компенсационный фонд, в
					который КПК платит взносы. Если в КПК что-то пойдет не так, пайщики могут рассчитывать на
					выплаты из фонда.
				</li>
				<li className={styles.orderedItem}>
					<b>Резервный фонд КПК — для покрытия возможных убытков.</b> По закону у каждого КПК должен
					быть свой резервный фонд. Обязанность иметь резервные фонды отражена в Указании Банка
					России от 14.07.2014 № 3322-У «О порядке формирования КПК резервов на возможные потери по
					займам».{' '}
				</li>
				<li className={styles.orderedItem}>
					<b>Скоринг клиента — не выдаём деньги кому попало.</b> Наши юристы проверяют заёмщика и
					всех участников сделки по более чем двадцати показателям. Если в ходе проверки мы замечаем
					что-то подозрительное, то отказываем в сделке.{' '}
				</li>
				<li className={styles.orderedItem}>
					<b>Скоринг недвижимости — выдаём займы только под залог квартир.</b> При этом проводим
					проверку залога в три этапа.
				</li>
			</ol>

			<h3 id='assessment-pledge' className={styles.title}>
				Оценка залога
			</h3>
			<p className={styles.paragraph}>
				Объект залога проходит тщательную проверку на предмет экономических и юридических рисков.
				Проверка состоит из трёх этапов.
			</p>
			<p className={styles.paragraph}>
				Первый — оценка стоимости недвижимости. Мы разработали сервис, который сравнивает объект с
				десятками предложений на рынке, а затем формирует отчёт с итоговой стоимостью.
			</p>
			<p className={styles.paragraph}>
				Второй — оценка ликвидности недвижимости. Объекты могут стоить одинаково, но один из них
				можно продать за 3 месяца, а другой — только за полтора года. И наша задача допустить до
				займа заёмщиков с ликвидной недвижимостью, которую можно быстро реализовать в случае
				дефолта. Ещё при оценке мы используем ценностный подход: прорабатываем все возможные
				сценарии погашения долга клиентом, чтобы он не оказался в сложной ситуации.
			</p>
			<p className={styles.paragraph}>
				Третий — юридическая проверка объекта. С помощью сервисов мы узнаём основания приобретения
				имущества и выясняем, есть ли риски оспаривания. Например, есть ли наследники или судебные
				решения по недвижимости. Мы отсекаем любые объекты, которые вызывают у нас подозрения.
			</p>

			<h3 id='assessment-borrower' className={styles.title}>
				Оценка заёмщика
			</h3>
			<p className={styles.paragraph}>
				При выдаче займа мы оцениваем заёмщика, залогодателя и поручителя. Каждый участник
				проверяется одинаково — независимо от роли в договоре.
			</p>
			<p className={styles.paragraph}>
				При проверке мы изучаем кредитную историю, платёжеспособность и общее финансовое состояние
				участников сделки. Мы узнаём о долгах, судах и отношениях с контрагентами. Если у нас
				возникают сомнения, мы откажемся от сотрудничества с заёмщиком.
			</p>
			<p className={cn(styles.paragraph, styles.paragraphBeforeList)}>
				На что обращаем внимание при скоринге:
			</p>

			<ol className={styles.orderedList}>
				<li className={styles.orderedItem}>Кредитная история из БКИ.</li>
				<li className={styles.orderedItem}>
					Внутренняя кредитная история, если участники сделки были нашими клиентами.
				</li>
				<li className={styles.orderedItem}>Наличие исполнительных производств и их размер.</li>
				<li className={styles.orderedItem}>
					Наличие любых судебных споров, финансовый размер притязаний, их суть и итог.
				</li>
				<li className={styles.orderedItem}>
					Отсутствие принадлежности к террористам, распространителям оружия, а также на наличие в
					реестре дисквалифицированных лиц.
				</li>
				<li className={styles.orderedItem}>
					Юридическая составляющая всех документов, необходимых для сделки.
				</li>
				<li className={styles.orderedItem}>
					Наличие предпосылок к банкротству или существующие дела о банкротстве.
				</li>
				<li className={styles.orderedItem}>Возраст участников сделки.</li>
				<li className={styles.orderedItem}>Возраст юридического лица.</li>
				<li className={styles.orderedItem}>
					Наличие статуса ИП и связь с иными юридическими лицами.
				</li>
				<li className={styles.orderedItem}>
					Финансовые показатели компании на основании выручки и баланса.
				</li>
			</ol>
		</article>
	)
}

export default Safety
